export function updateStep5Action(
  state: any,
  payload: {
    // step5
    applicationProcess: any;
    immHiringNeed: any;
    diversityStatement: any;
    faq: any;

    postStatus: any;
    progressStep: any;
  }
) {
  return {
    ...state,
    data: {
      ...state.data,
      ...payload,
    },
  };
}
